import { Box, Typography } from "@mui/material";
import {
  CustomDatePicker,
  CustomDropdown,
  CustomFileInput,
  CustomNumberInput,
  CustomTextarea,
  CustomTextInput,
  CustomAutocomplete,
  CustomSwitch,
  CustomAddress,
} from "components/atoms";
import CustomESign from "components/atoms/CustomESign";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { generateURL } from "../services";
import { formattedTime, getItem, showToast } from "services/utils";
import { cloneDeep } from "lodash";
import CustomeFilePreview from "components/atoms/CustomeFilePreview";
import moment from "moment";
import { Constants } from "services/keyConstants";
import CustomSliderInput from "components/atoms/CustomSliderInput";
import CustomRatingInput from "components/atoms/CustomRatingInput";
import CustomDateRangePicker from "components/atoms/CustomDateRangePicker";
import CustomTime from "components/atoms/CustomTime";

const FormCell = (props) => {
  const {
    rows,
    column,
    columnIndex,
    config,
    errorRef,
    isDisable: haveDisable = false,
    helperFunction,
    isLock: filedRowLock,
  } = props;
  const { error, msg: errorMsg } = errorRef.current?.[column?.uniqueName] ?? {
    error: false,
    errorMsg: "",
  };
  const { helperUtils, handleVisibility, hasEmptyValue, isISODateString } =
    helperFunction;
  const {
    isViewMode = false,
    onESign = false,
    multipleESign = false,
    chip = false,
    navLink = false,
    renderForm,
    hidden = false,
    dependencyFields = false,
    renderColumns,
    dynamicOptionsByRows = false,
    onChangeHandler = false, // New: Added support for onChangeHandler like in NestedRowCell
    userData,
    trackChanges = false,
  } = config;

  const navigate = useNavigate();
  const [_, forceRender] = useState({});
  const [esignOpen, setEsignOpen] = useState(false);
  const render = () => forceRender({});

  const value = rows?.[column?.uniqueName];
  let isLock = !!rows?.isLock || filedRowLock || !!column?.formatText;
  const isDisable = haveDisable || !!column?.formatText;

  const passCurrentData = {
    column,
    rows,
    columnIndex,
  };

  // if (column?.uniqueName === "") {
  //   rows[column?.uniqueName] = ""
  // }

  const handleChange = (newValue, changeMethod = null) => {
    if (!!onChangeHandler) {
      const changeHandlerKeys = Object.keys(onChangeHandler);
      changeHandlerKeys.forEach((ky) => {
        if (column?.uniqueName === ky) {
          const { before = () => {}, after = () => {} } = onChangeHandler[ky];
          before(
            () => {
              handleUpdateValue(newValue, changeMethod);
              after(cloneDeep(passCurrentData));
            },
            {
              newValue: newValue,
              oldValue: value,
              ...(!!changeMethod && { changeMethod }),
            },
            renderForm
          );
          return;
        }
        handleUpdateValue(newValue, changeMethod);
      });
      return;
    }
    handleUpdateValue(newValue, changeMethod);
  };

  const handleUpdateValue = (newValue, changeMethod) => {
    if (column?.type === "multipleEsign") {
      if (!Array.isArray(rows[column?.uniqueName])) {
        rows[column?.uniqueName] = [];
      }
      rows[column?.uniqueName].push(newValue);
    } else {
      rows[column?.uniqueName] = newValue;
    }
    // rows[column?.uniqueName] = newValue;
    trackChanges[column.uniqueName] = newValue;
    delete errorRef?.current?.[column.uniqueName];
    if (hidden !== false) {
      if (Object.keys(hidden).includes(column?.uniqueName)) {
        const unShowFields = hidden?.[column?.uniqueName]?.handler(
          cloneDeep(passCurrentData)
        );
        handleVisibility(unShowFields);
      }
    }
    if (dependencyFields !== false) {
      if (Object.keys(dependencyFields).includes(column?.uniqueName)) {
        const { type = "row", handler = () => {} } =
          dependencyFields?.[column?.uniqueName];
        if (type === "row") {
          const newData = handler(passCurrentData) ?? {};
          Object.keys(newData).forEach((col) => {
            if (Object.keys(rows).includes(col)) {
              rows[col] = newData?.[col];
              renderColumns?.[col]();
            }
          });
        }
      }
    }

    if (
      dynamicOptionsByRows !== false &&
      Object.keys(dynamicOptionsByRows).includes(column?.uniqueName)
    ) {
      const { handler = () => {} } = dynamicOptionsByRows?.[column?.uniqueName];
      const newOptions = handler(cloneDeep(passCurrentData)) ?? {};
      Object.keys(newOptions).forEach((col) => {
        // if (Object.keys(rows).includes(col)) {
        rows[col] = "";
        rows.customOptions = rows.customOptions || {};
        rows.customOptions[col] = newOptions[col];
        renderColumns?.[col]();
        // }
      });
    }

    render();
  };

  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  if ((!value || value === "") && (column?.isReadOnly || isViewMode)) {
    return <Typography> - </Typography>;
  } else if (
    isViewMode ||
    ((isLock || isDisable) && !["", undefined, null].includes(value)) ||
    // isLock ||
    // (isDisable && value !== "" && value?.length !== 0) ||
    !!column?.isReadOnly
  ) {
    let cellValue = null;
    if (column?.type === "file") {
      return <CustomeFilePreview files={value} />;
    } else if (column?.type === "multipleEsign") {
      cellValue = value
        ?.map(
          (i) => i?.userData?.userDesignation + " " + formattedTime(i?.time)
        )
        ?.join(",");
    } else if (Array.isArray(rows?.[column?.uniqueName])) {
      cellValue = column?.renderOptionValue
        ? rows?.[column?.uniqueName]
            ?.map((o) => o?.[column?.renderOptionValue])
            ?.join(", ")
        : rows?.[column?.uniqueName]?.length !== 0
        ? rows?.[column?.uniqueName]?.join(", ")
        : null;
    } else if (column?.type === "esign") {
      const constFormate = getItem(Constants?.DATE_FORMATE);
      cellValue =
        value?.userData?.name && value?.userData?.designation
          ? `${value?.userData?.name} - ${value?.userData?.designation} - ${
              isISODateString(value?.time)
                ? moment(value?.time).format(
                    constFormate || "DD/MM/YYYY hh:mm A"
                  )
                : value?.time ?? "N/A"
            }`
          : "";
    } else if (column?.type === "date") {
      const constFormate = getItem(Constants?.DATE_FORMATE);
      cellValue = isISODateString(value)
        ? moment(value).format(!!constFormate ? constFormate : "DD/MM/YYYY")
        : value;
    } else if (column?.type === "datetime") {
      const constFormate = getItem(Constants?.DATE_FORMATE);

      if (isISODateString(value)) {
        const datePart = moment(value).format(constFormate || "DD/MM/YYYY");
        const timePart = moment(value).format("hh:mm A");
        cellValue = (
          <div>
            <div>{datePart} - {timePart}</div>
          </div>
        );
      } else {
        cellValue = value ?? "N/A";
      }
    } else if (column?.type === "dateRange") {
      cellValue = isISODateString(value)
        ? moment(value).format(getItem(Constants.DATE_FORMATE) || "DD/MM/YYYY")
        : value;
    } else if (column?.type === "dropdown") {
      cellValue =
        typeof value === "string"
          ? value
          : Array.isArray(value)
          ? value.join(", ")
          : value?.[column?.renderOptionValue];
    } else if (column?.type === "dynamicDropdown") {
      cellValue =
        typeof value === "string"
          ? value
          : Array.isArray(value)
          ? value.join(", ")
          : value?.[column?.renderOptionValue];
    } else if (column?.type === "address") {
      return (
        <Typography>
          {value?.finalAddress ? value?.finalAddress : value ? value : "N/A"}
        </Typography>
      );
    } else if (["scale", "rating"].includes(column?.type)) {
      const commonProps = {
        name,
        value,
        onChange: handleChange,
        error,
        helperText: errorMsg,
        isLock: true,
        isReadOnly: true,
      };

      return column?.type === "scale" ? (
        <CustomSliderInput {...commonProps} min={0} max={5} step={0.5} />
      ) : (
        <CustomRatingInput
          {...commonProps}
          label={column?.name}
          max={column?.max ?? 5}
          precision={0.5}
        />
      );
    } else {
      cellValue = Array.isArray(value) ? value.join(", ") : value;
    }
    return <Typography>{cellValue === null ? "N/A" : cellValue}</Typography>;
  } else if (column?.type === "scale") {
    return (
      <Box sx={{ width: 200, mt: 2 }}>
        <CustomSliderInput
          name={column?.uniqueName}
          value={value}
          onChange={handleChange}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
          min={column?.min ?? 0}
          max={column?.max ?? 5}
          step={column?.step ?? 0.5}
        />
      </Box>
    );
  } else if (column?.type === "rating") {
    return (
      <CustomRatingInput
        label={column?.name}
        name={column?.uniqueName}
        value={value}
        onChange={handleChange}
        error={error}
        helperText={errorMsg}
        max={column?.max ?? 5}
        precision={column?.precision ?? 0.5}
        isLock={isLock || isDisable}
        isReadOnly={!!column?.isReadOnly}
      />
    );
  } else if (column?.type === "text") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomTextInput
          label={`Enter ${column?.name}`}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
        />
      </Box>
    );
  } else if (column?.type === "number") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomNumberInput
          label={`Enter ${column?.name}`}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
        />
      </Box>
    );
  } else if (column?.type === "dropdown") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomDropdown
          label={false}
          name={column.uniqueName}
          value={value}
          onChange={(value) => {
            handleChange(value);
          }}
          // options={column?.options}
          options={
            rows?.customOptions?.[column?.uniqueName]?.length > 0
              ? rows?.customOptions?.[column?.uniqueName]
              : column?.options
          }
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
          renderOptionKey={
            column?.renderOptionValue ? column?.renderOptionValue : false
          }
        />
      </Box>
    );
  } else if (column?.type === "dynamicDropdown") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomAutocomplete
          label={column.name}
          name={column.uniqueName}
          value={value}
          onChange={(value) => {
            handleChange(value);
          }}
          // options={column?.options ?? []}
          options={
            rows?.customOptions?.[column?.uniqueName]?.length > 0
              ? rows?.customOptions?.[column?.uniqueName]
              : column?.options ?? []
          }
          multiple={column?.multiple}
          freeSolo={column?.freeSolo ?? true}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
          renderOptionKey={
            column?.renderOptionValue ? column?.renderOptionValue : false
          }
        />
      </Box>
    );
  } else if (column?.type === "address") {
    if (hasEmptyValue(value)) {
      return (
        <Box
          sx={{
            ...commonStyle,
          }}
        >
          <CustomAddress
            action={"add"}
            label={column.name}
            name={column.uniqueName}
            value={value}
            onChange={(value) => {
              handleChange(value);
            }}
            error={error}
            helperText={errorMsg}
            isLock={isLock || isDisable}
            isReadOnly={!!column?.isReadOnly}
          />
        </Box>
      );
    } else {
      return (
        <Box
          sx={{
            ...commonStyle,
            gap: "20px",
          }}
        >
          <Typography>{value?.finalAddress}</Typography>
          <CustomAddress
            action={!!value?.finalAddress ? "edit" : "add"}
            label={column.name}
            name={column.uniqueName}
            value={value ?? {}}
            onChange={(value) => {
              handleChange(value);
            }}
            error={error}
            helperText={errorMsg}
            isLock={isLock || isDisable}
            isReadOnly={!!column?.isReadOnly}
          />
        </Box>
      );
    }
  } else if (column?.type === "textarea") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomTextarea
          label={`Enter ${column?.name}`}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          error={error}
          helperText={errorMsg}
          isLock={isLock}
          isReadOnly={!!column?.isReadOnly}
        />
      </Box>
    );
  } else if (column?.type === "switch") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomSwitch
          label={column?.label}
          name={column?.uniqueName}
          checked={!!value}
          onChange={(val) => handleChange(val)}
          error={error}
          helperText={errorMsg}
          isReadOnly={!!column?.isReadOnly}
          isLock={isDisable}
        />
      </Box>
    );
  } else if (column?.type === "dateRange") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomDateRangePicker
          label={column.name}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e);
          }}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
        />
      </Box>
    );
  } else if (["date", "datetime"]?.includes(column?.type)) {

    if (!value && !moment(value).isValid()) {
      rows[column?.uniqueName] = moment().toISOString();
      render();
    }

    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomDatePicker
          label={column.name}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e);
          }}
          disablePast={column?.disablePast}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
          dateTime={column?.type === "datetime"}
          minValue={column?.minValue}
          maxValue={column?.maxValue}
        />
      </Box>
    );
  } else if (column?.type === "esign") {
    const beforeOpen = (state) => {
      const before = onESign?.before || {};
      const checkValidation = before?.checkValidation ?? true;
      const handler = before?.handler ?? false;
      if (onESign !== false) {
        if (checkValidation && !helperUtils("checkValidation", rows)) {
          return;
        }
        if (handler) {
          handler(state, passCurrentData);
        } else {
          state();
        }
      } else {
        state();
      }
    };
    const handleSubmit = (submitStatus) => {
      const eSignData = helperUtils("esignData");
      if (submitStatus) {
        if (multipleESign !== false) {
          const { format, start } = multipleESign;
          const isLastStep =
            rows?.currentESignStep === format?.[format.length - 1];
          if (isLastStep) {
            delete rows?.currentESignStep;
            rows.submitted = true;
            rows.isLock = true;
          } else {
            const nextIndex = format?.indexOf(rows?.currentESignStep) + 1;
            rows.currentESignStep = format[nextIndex];
          }
        }
        handleChange(eSignData);
        showToast("Submit successfully", true);
        onESign?.after?.(submitStatus, eSignData, passCurrentData);
      } else {
        onESign?.after?.(submitStatus, null, passCurrentData);
        showToast("Submit failed", false);
      }
      // renderForm();
      render();
    };

    if (!!value) {
      const { time = false, userData = {} } = value;
      const constFormate = getItem(Constants?.DATE_FORMATE);

      return (
        <Box
          sx={{
            py: "6px",
          }}
        >
          <Typography variant="h6" color="text.primary">
            {userData?.name ?? "N/A"}
          </Typography>
          <Typography variant="h6" color="text.primary">
            {userData?.designation ?? "N/A"}
          </Typography>
          <Typography variant="h6" color="text.primary">
            {isISODateString(time)
              ? moment(time).format(
                  !!constFormate ? constFormate : "DD/MM/YYYY hh:mm A"
                )
              : time ?? "N/A"}
          </Typography>
        </Box>
      );
    }

    return (
      <CustomESign
        open={esignOpen}
        setOpen={setEsignOpen}
        handleSubmit={handleSubmit}
        beforeOpen={beforeOpen}
        // disabled={isLock || isDisable}
        disabled={isLock || isDisable || onESign?.isEsignDisable}
      />
    );
  } else if (column?.type === "multipleEsign") {
    const handleSubmit = (submitStatus) => {
      const eSignData = helperUtils("esignData");
      if (submitStatus) {
        handleChange(eSignData);
        showToast("Submit successfully", true);
        onESign?.after?.(submitStatus, eSignData, passCurrentData);
      } else {
        onESign?.after?.(submitStatus, null, passCurrentData);
        showToast("Submit failed", false);
      }
      renderForm();
    };

    return rows[column?.check]?.map((i) => (
      <CustomESign
        open={esignOpen}
        setOpen={setEsignOpen}
        handleSubmit={handleSubmit}
        buttonName={i?.userDesignation + " Esign"}
        disabled={isLock || isDisable || !(i?.userId === userData?._id)}
      />
    ));
  } else if (column?.type === "time") {
    return (
      <>
        <CustomTime
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          label={`Enter ${column?.name}`}
          name={column?.name}
          value={value}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
          isReadOnly={!!column?.isReadOnly}
        />
      </>
    );
  } else if (column?.type === "file") {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomFileInput
          label={"Please upload a Document"}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          multiple={column?.multiple}
          error={error}
          helperText={errorMsg}
          isLock={isLock}
        />
      </Box>
    );
  } else if (column?.type === "chip") {
    let chipData = false;

    chip !== false && !!chip?.[column?.uniqueName] !== false
      ? (chipData = chip[column?.uniqueName](passCurrentData))
      : chipData !== false;

    const handleClick = () => {
      chipData?.onClick && chipData?.onClick(passCurrentData);
    };

    return (
      <CustomizeChip
        label={chipData?.label ?? "Chip"}
        size={chipData?.size ?? "medium"}
        variant={chipData?.variant ?? "filled"}
        color={chipData?.color ?? "success"}
        onClick={column?.navigateUrl ? handleClick : null}
      />
    );
  } else if (column?.type === "navigation") {
    const navigateUrl = () => {
      const helperUrlObj =
        navLink !== false && !!navLink?.[column?.uniqueName] !== false
          ? navLink[column?.uniqueName](passCurrentData)
          : {};
      const generatedUrl = generateURL(column?.url, helperUrlObj);
      navigate(generatedUrl, { replace: true });
    };

    return <Button onClick={navigateUrl}>Link</Button>;
  } else {
    return (
      <Box
        sx={{
          ...commonStyle,
        }}
      >
        <CustomTextInput
          label={`Enter ${column?.name}`}
          name={column.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          error={error}
          helperText={errorMsg}
          isLock={isLock || isDisable}
        />
      </Box>
    );
  }
};

export default FormCell;
